var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media_holder"},[_c('div',{class:{ active_iframe: true, hidden: _vm.isIframeHidden }},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"id":"iframeScroller"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }